import api from '@/api/api';
import { TSRMPricingResponse, TSRMultiPricingParams } from './srm.types';

export const srmPricingEndpoint = 'punter/pricing/srm';

export async function mutatePricing(body: TSRMultiPricingParams) {
  const res = await api.post<TSRMPricingResponse>(srmPricingEndpoint, body);
  return res;
}
